'use strict';

define('RaceLinkFilter',[],
    function () {
        function RaceLinkFilter(RaceUrlFac) {
            return function(race) {
                return RaceUrlFac.calculateRacePath(race.trackAbbr, race.perfAbbr, race.raceNumber);
            };
        }

        RaceLinkFilter.$inject = [
            'RaceUrlFac'
        ];

        return RaceLinkFilter;
    }
);

